/* eslint-disable @typescript-eslint/no-explicit-any */
import { CORE_PLUGIN, CORE_ROUTER, CORE_ROUTER_EXTEND, RouteExtend } from '../../../core'
import type { ConsolePageOption, ConsolePageService, Plugin } from '../../index'
import {
  PLUGIN_CONSOLE_PAGE,
  PLUGIN_ERROR_PAGE,
} from '../../builtin/BuiltinPluginSymbol'
import {
  container,
  injectable,
  instanceCachingFactory,
  registry,
  singleton,
} from 'tsyringe'
import type { App } from 'vue'
import type { Router } from 'vue-router'
import Error404 from './views/Error404Page.vue'
import Error500 from './views/Error500Page.vue'
import Error504 from './views/Error504Page.vue'

/**
 * 插件的Option定义
 */
export const createDefaultErrorPageOption = () => {
  return {
    errorPages: [
      {
        path: '/:pathMatch(.*)',
        component: Error404 as any,
      },
      {
        path: '/504',
        component: Error504 as any,
      },
      {
        path: '/500',
        component: Error500 as any,
      },
    ],
    createErrorPages: [] as any,
  }
}
export const defaultErrorPageOption = createDefaultErrorPageOption()
export type ErrorPageOption = typeof defaultErrorPageOption

@singleton()
@registry([
  {
    token: CORE_PLUGIN,
    useFactory: instanceCachingFactory<Plugin<ErrorPageOption, unknown>>((c) =>
      c.resolve(DefaultErrorPagePlugin)
    ),
  },
])
@injectable()
export class DefaultErrorPagePlugin
  implements Plugin<ErrorPageOption, unknown>
{
  id: string | symbol = PLUGIN_ERROR_PAGE
  options: ErrorPageOption
  service: unknown

  constructor() {
    this.options = createDefaultErrorPageOption()
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  init(app: App<Element>): void {
    this.options.errorPages.forEach((item) => {
      const list: any = {}
      list.path = item.path.substring(1)
      list.component = item.component
      this.options.createErrorPages.push(list)
    })
    const router = container.resolve<Router>(CORE_ROUTER)
    const routeExtend = container.resolve<RouteExtend>(CORE_ROUTER_EXTEND)
    this.options.errorPages.forEach((item) => {
      router.addRoute({
        path: item.path,
        component: item.component,
        beforeEnter: [routeExtend.authRouter]
      })
    })
    const plugin =
      container.resolve<Plugin<ConsolePageOption, ConsolePageService>>(
        PLUGIN_CONSOLE_PAGE
      )
    this.options.createErrorPages.forEach((item: any) => {
      plugin.service.addChildRoute(item)
    })
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  initialized(app: App<Element>): void {

  }
}
